module.exports = __webpack_public_path__ + "img/map-marker.bd08027c.svg";